/**
 * @desc 导入修改运费
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/waybillMaster/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
